export default __webpack_public_path__ + "static/PM_Frog-25adb65f314bfaea036bf9fb7566909f.png";